// let arrayArticles = []
// let arraySpecificArticles = []
export const initTopRandom = () => {
  const topArticlesWrapper = document.querySelector('.top-articles .swiper-wrapper')
  const topArticles = document.querySelectorAll('.top-article')
  // topArticles.forEach((topArticle, i) => {
  //   if (topArticle.dataset.category === 'OUR PLACE') {
  //     arraySpecificArticles.push()
  //   }
  //   topArticlesWrapper.appendChild(topArticles[(Math.random() * i) | 0])
  // })
  for (let i = topArticles.length; i >= 0; i--) {
    topArticlesWrapper.appendChild(topArticles[(Math.random() * i) | 0])
  }
}
